'use client';

import { useEffect } from "react";
import { usePathname } from "next/navigation";
export default function FloatingCartManager() {
    const pathname = usePathname();
    useEffect(() => {
        document.body.classList.remove('floating-cart-visible');
    }, [pathname]);
  return null;
}